export default __webpack_public_path__ + "static/media/about-banner.e33d9b48.jpg";